export default "__VITE_ASSET__UBIkyonT__"